import viewportUnits from "./func/viewport-units";
import hamburguerMenu from "./func/hamburguer-menu";
import headerFunctions from "./func/header";
import servicesHome from "./func/services-home";
import productsHome from "./func/products-home";
import alliancesHome from "./func/alliances-home";
import newsHome from "./func/news-home";
import langmenu from "./func/langmenu";
import statisticCounter from "./func/statistic-counter";
import serviceGridCarousel from "./func/service-grid";
import featuresCarousel from "./func/feature-dservice";
import processCarousel from "./func/process-dservice";
import featurDetProdCarousel from "./func/feature-dproduct";
import acordeon from "./func/acordeon";
import { allFilterbarFunctions, createTagsFilters, otherFilterFuntions} from "./func/filterbar";
import certificatesCarousel from "./func/certificates-carousel";
import alliancesAboutCarousel from "./func/alliances-about";
import teamCarousel from "./func/team-carousel";
import formFunctions from "./func/form";
import specificationFilter from "./func/specifications-dproduct";
import popupGallery from "./func/popupGallery";
import newsBlogTitle from "./func/news-blog-title";
import linkedinHome from "./func/linkedin-home";
import tagsCarousel from "./func/tags-carousel";
import searchModal from "./func/searchModal";

let timeoutViewportUnits = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback

/*==================== WINDOW RESIZE ====================*/
window.addEventListener('resize', function () {
  this.clearTimeout(timeoutViewportUnits);
  timeoutViewportUnits = this.setTimeout(viewportUnits(), delay);
});

/*==================== PETICIÓN AJAX COMPLETADA ====================*/
jQuery(document).on("ajaxComplete", function(event, jqxhr, settings){
  // Filtro detalle producto
  specificationFilter();
  // carrusel features detalle producto
  featurDetProdCarousel();

  // Acordeon Detalle Producto
  acordeon();

  // Delay Animaciones Detalle Producto
  delayToItems('.specifications__list .specification-item', 300, 150);
  delayToItems('.product-features__list .feature-item', 300, 150);

  // Filtros Listado Productos
  // Verifica si la entrada "applyButtonClicked" está presente en el sessionStorage
  const applyButtonClicked = sessionStorage.getItem('applyButtonClicked');
  if (applyButtonClicked === 'true') {
    // Mostrar los tags de filtros aplicados
    allFilterbarFunctions();  
    // Limpia la entrada en el sessionStorage
    sessionStorage.removeItem('applyButtonClicked');
  }else{
    otherFilterFuntions();
  }

  // Formularios (validaciones y reemplazo btns)
  formFunctions();

  // Home Productos
  productsHome();

  // Tags tarjetas
  tagsCarousel();

  // Resetear animaciones
  AOS.refreshHard();
});

/*==================== ANIMACIONES ====================*/
function addAnimation(selector, objectOptions){
  let $element = jQuery(selector);
  if($element.length){
    $element.attr(objectOptions);
  }
}

function delayToItems(selector, startDelay= 300, delayIncrement = 150){
  jQuery(selector).each(function(){
    addAnimation(
      this,
      {
        'data-aos-delay': startDelay.toString()
      }
    );
    startDelay = startDelay + delayIncrement;
  });
}

function setAnimations(){
  // Home
  delayToItems('.service-home__list .service-card', 300, 150);

  // Interna Listado servicios
  delayToItems('.block-service.block-service--grid .block-service__list .benefit-card.benefit-card--type1', 300, 150);

  delayToItems('.block-service.block-service--largeimg .block-service__list .benefit-card.benefit-card--type3', 300, 150);

  // Contactanos
  delayToItems('.block-channels__list .channel-item', 300, 150);

  // Detalle Producto
  delayToItems('.specifications__list .specification-item', 300, 150);
  delayToItems('.product-features__list .feature-item', 300, 150);
  
}

/*==================== READY ====================*/
document.addEventListener('DOMContentLoaded', function(){
  viewportUnits();
  langmenu();
  headerFunctions();
  hamburguerMenu();
  searchModal();
  statisticCounter();
  servicesHome();
  productsHome();
  alliancesHome();
  newsHome();
  linkedinHome();
  formFunctions();
  serviceGridCarousel();
  featuresCarousel();
  processCarousel();
  featurDetProdCarousel();
  acordeon();
  allFilterbarFunctions();
  certificatesCarousel();
  alliancesAboutCarousel();
  teamCarousel();
  specificationFilter();
  setAnimations();
  popupGallery();
  newsBlogTitle();
  tagsCarousel();

  // Inicializamos plugin animaciones
  AOS.init({
    once: false,
  });
  
});

/*==================== LOAD ====================*/
jQuery(document).on('load', function(){
  AOS.refreshHard();
});